import { ListChecks, MapPinned } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { ChecklistItem } from '~/api/types'
import { RailCard } from './rail-card'
import type { ResultItem } from './types'

/** 전체 체크리스트 기준의 영향 범위(요약)와 전체 체크리스트 카탈로그 진입점을 표시한다.
 *  보고서 열기는 결과 카드의 "보고서 보기"로 일원화했다(중복 버튼 제거). */
export function ChecklistOverviewCard({
    checklist,
    resultItems,
    unaffectedCount,
}: {
    checklist: ChecklistItem[]
    resultItems: ResultItem[]
    unaffectedCount: number
}) {
    return (
        <RailCard title='전체 체크리스트 관점'>
            <div className='grid gap-3 text-sm'>
                <div className='border-border flex items-start gap-2 rounded-sm border p-2'>
                    <MapPinned className='text-primary mt-0.5 size-4 shrink-0' />
                    <span className='text-muted-foreground'>
                        전체 {checklist.length}개 중 {resultItems.length}개
                        영향, {unaffectedCount}개 영향 없음
                    </span>
                </div>
                <Link
                    to='/explore'
                    className='border-border hover:border-primary hover:text-primary text-foreground flex items-center justify-center gap-2 rounded-sm border p-2 font-medium'>
                    <ListChecks className='size-4 shrink-0' />
                    전체 체크리스트 보기
                </Link>
            </div>
        </RailCard>
    )
}
